import Vue from 'vue';
import YmapPlugin from "vue-yandex-maps";

const settings = {
    apiKey: 'bd37fd51-6c34-4b5b-83a9-78c07d0567ca',
    lang: 'ru_RU',
    coordorder: 'latlong',
    enterprise: false,
    version: '2.1'
}

Vue.use(YmapPlugin, settings);

export default new YmapPlugin.install();